import gql from 'graphql-tag';

export default gql`
  query storeBuyersByStoreIds($storeIds: [String!]!) {
    storeBuyersByStoreIds(storeIds: $storeIds) {
      storeId
      storeName
      buyerId
      buyerName
    }
  }
`;
